import type {Components} from '@mui/material';

export const MuiDrawer: Components['MuiDrawer'] = {
  defaultProps: {
    SlideProps: {
      style: {
        visibility: undefined,
      },
    },
  },
};
